export const tryWrapper = (func, errorHandler = console.error) => {
  let res
  try {
    res = func()
  } catch(e) {
    errorHandler(e)
  }
  return res
}
